import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 30 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 36\" id=\"arrow-left\">\n  <path d=\"M1.87 20.453l22.933 14.909a3 3 0 004.635-2.516V3.03A3 3 0 0024.803.514L1.869 15.422a3 3 0 000 5.03z\" fill=\"#003595\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol